import type { RecordFormMetadata } from '../../../types/record-form';

export const buildRecordFormMetadata = (metadata: any, tableName: string): RecordFormMetadata => {
  if (!metadata) {
    return {
      fields: undefined,
      picklists: undefined,
      relationships: undefined,
      clientSideTables: [],
      clientSideSelectTables: {},
      routeData: { tableToRouteName: {} },
      tableData: { byName: {} }
    };
  }

  return {
    fields: metadata.fieldData?.[tableName]?.byFieldName,
    picklists: metadata.picklistData?.[tableName]?.byFieldName,
    relationships: metadata.relationshipLookupData?.[tableName]?.byFieldName,
    clientSideTables: Object.keys(metadata.clientSideSelectTables || {}).filter((key) => key !== 'flattened'),
    clientSideSelectTables: metadata.clientSideSelectTables || { flattened: {} },
    routeData: metadata.routeData || { tableToRouteName: {} },
    tableData: { byName: metadata.tableData?.byName || {} }
  };
};
